export default __webpack_public_path__ + "static/media/IMG_2080.5445db03.jpg";